import { render, staticRenderFns } from "./MedicsView.vue?vue&type=template&id=53d128f0"
import script from "./MedicsView.vue?vue&type=script&lang=js"
export * from "./MedicsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports